import { Box, SxProps } from "@mui/material";
import styles from "./style.module.css";

interface PulseAnimationProps {
  sx?: SxProps;
}

const PulseAnimation = ({ sx }: PulseAnimationProps) => {
  return <Box className={`${styles.circle} ${styles.pulse} `} sx={sx} />;
};

export default PulseAnimation;
